import controller from './nosub.controller';
import '../student.less';

export default {
  controller,
  template: require('./nosub.html')
};



// WEBPACK FOOTER //
// src/app/components/student/nosub/nosub.component.ts